@if(corporateTaxEntity$ | async) {
  <form [formGroup]="bronheffingFg">
    <div formArrayName="bronheffingen">
      @for (item of bronheffingen.controls; track item; let i = $index) {
        <div [formGroupName]="i" class="row mb-1">
          <div class="col-auto">
            <snelstart-ui-select-form-control [label]="i === 0 ? 'Land' : ''"
                                              [options]="optionsLandcodes"
                                              class="custom-input-250"
                                              formControlName="landcode"
            >
            </snelstart-ui-select-form-control>
          </div>
          <div class="col-auto">
            <snelstart-ui-number-form-control [label]="i === 0 ? 'Dividend' : ''"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150" formControlName="brutoDividend"
                                              id="brutoDividend"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto">
            <snelstart-ui-number-form-control [label]="i === 0 ? 'Rente' : ''"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150" formControlName="brutoRente"
                                              id="brutoRente"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto">
            <snelstart-ui-number-form-control [label]="i === 0 ? 'Kosten' : ''"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150" formControlName="aftrekbareKosten"
                                              id="aftrekbareKosten"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto">
            <snelstart-ui-number-form-control [label]="i === 0 ? 'Bronheffing' : ''"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150" formControlName="verrekenbareBronheffing"
                                              id="verrekenbareBronheffing"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto">
            <snelstart-ui-button
              (click)="verwijderRij(i)"
              [class]="i === 0 ? 'firstrowbutton' : ''"
              icon="trash"
              iconType="light"
              id="buttonDelete"
              size="medium"
              type="secondary"
            >
            </snelstart-ui-button>
          </div>
        </div>
      }
    </div>
  </form>

  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus" id="cancel"
                       type="link">Bronheffing toevoegen
  </snelstart-ui-button>
}

